import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}packing/retry`;

export interface RetryPackingCommandPayload {
  packingParcelId: string;
  startTimeInLocalRecipientTimezone?: string;
  endTimeInLocalRecipientTimezone?: string;
}

export async function retryPackingCommand(
  payload: RetryPackingCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}
